import { Resolutions, Timeout } from "../common/const";
import { isWidthResize, getSiblings, findAncestorByClassname } from '../common/utils';

/**
 * @slider
 * @constructor
 */
class Slider {
    /**
     * @param {object} el Slider container
     * @param {object} properties Props of swiper slider (loop, speed, autoplay...)
     * @param {number} minNumber Minimal numbers of slides in slider
     */

    constructor(block) {
        this.block = block;
        this.el = this.block.querySelector(`.swiper-container`);
        this.minNumber = this.block.getAttribute(`data-slider-min`);
        this.minNumberTablet = this.block.getAttribute(`data-slider-min-tablet`);
        this.minNumberMobile = this.block.getAttribute(`data-slider-min-mobile`);
        // this.resolution = this.block.getAttribute(`data-slider-resolution`);
        this.effect = this.block.getAttribute(`data-slider-effect`);
        this.autoplay = this.block.getAttribute(`data-slider-autoplay`);
        this.pagBlock = this.block.querySelector(`[data-slider-pag]`);
        this.freeMode = this.block.getAttribute(`data-slide-freemode`);
        if (this.pagBlock) this.pags = this.pagBlock.querySelectorAll(`[data-pag]`);
        this.onWidthResize = () => this.onResize();
    }

    getSliderLength() {
        let slides = this.el.querySelectorAll(`.swiper-slide`);
        return slides;
    }

    makeSlider(el) {
        if (!el) return undefined;

        const prevBtn = el.querySelector(`.swiper-button-prev`) || el.parentNode.querySelector(`.swiper-button-prev`);
        const nextBtn = el.querySelector(`.swiper-button-next`) || el.parentNode.querySelector(`.swiper-button-next`);
        const progressbar = el.querySelector(`.swiper-progressbar`) || el.parentNode.querySelector(`.swiper-progressbar`);

        let slider = new Swiper(el, {
            allowTouchMove: true,
            autoplay: this.autoplay ? {
                delay: this.autoplay,
                disableOnInteraction: false,
            } : false,
            breakpoints: {
                // [ScreenWidth.TABLET]: {
                //     enabled: this.minNumberTablet > this.getSliderLength().length
                // },
                // [ScreenWidth.MOB]: {
                //     enabled: this.minNumberMobile > this.getSliderLength().length
                // },
            },
            centeredSlides: this.block.getAttribute(`data-slider-centered`),
            coverflowEffect: {},
            direction: `horizontal`,
            effect: this.effect,
            freeMode: this.freeMode,
            loop: this.block.getAttribute(`data-slider-loop`),
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            observeParents: true,
            observer: true,
            observeSlideChildren: true,
            pagination: {
                el: progressbar ? progressbar : this.block.querySelector(`.swiper-pagination`),
                type: progressbar ? `progressbar` : `bullets`,
                clickable: true
            },
            preventClicksPropagation: true,
            preventInteractionOnTransition: true,
            scrollbar: {
                el: el.querySelector(`.swiper-scrollbar`),
                draggable: true,
            },
            slidesPerGroup: 1,
            slidesPerView: `auto`,
            slideToClickedSlide: false,
            spaceBetween: 0,
            speed: 400,

            onTouchStart: function () {
                allowClick = true;
            },

            onTouchMove: function () {
                allowClick = false;
            },

            onTouchEnd: function () {
                setTimeout(function() {
                    allowClick = true;
                }, Timeout.SHORT_TIMEOUT);
            },

            on: {
                init() {
                    this.el.classList.add(`start`);
                },

                resize: function() {
                    // this.update();
                },

                reachBeginning: function() {
                    this.el.classList.remove(`end`);
                    this.el.classList.add(`start`);
                },

                slideChange: function() {
                    this.el.classList.remove(`start`);
                    this.el.classList.remove(`end`);

                    if (this.activeIndex === 0) {
                        this.el.classList.add(`start`);
                        this.el.classList.remove(`end`);
                    }
                },

                slideChangeTransitionStart: function() {
                },

                slideChangeTransitionEnd: function() {
                    // this.slideToLoop(this.realIndex, 0, false);
                },

                reachEnd: function() {
                    this.el.classList.remove(`start`);
                    this.el.classList.add(`end`);
                },
            }
        });

        return slider;
    }

    enableSlider() {
        this.el.classList.remove(`disabled`);
        this.disabled = false;
    }

    disableSlider() {
        this.el.classList.add(`disabled`);
        this.disabled = true;
    }

    destroySlider(slider) {
        if (slider !== undefined) {
            slider.destroy(true, true);
            slider = undefined;
        }

        return slider;
    }

    onLoad() {
        if (Resolutions.IS_MOB()) {
            if (this.getSliderLength().length < this.minNumberMobile || this.minNumberMobile == 0) {
                this.disableSlider();
            } else {
                this.enableSlider();
            }
        } else if (Resolutions.IS_TAB_ONLY()) {
            if (this.getSliderLength().length < this.minNumberTablet || this.minNumberTablet == 0) {
                this.disableSlider();
            } else {
                this.enableSlider();
            }
        } else if (Resolutions.IS_DP()) {
            if (this.getSliderLength().length < this.minNumber || this.minNumber == 0) {
                this.disableSlider();
            } else {
                this.enableSlider();
            }
        }

        if (this.slider === undefined && !this.disabled) {
            this.slider = this.makeSlider(this.el);
            if (this.pagBlock) this.initPagination();
        }

        this.initSideSlideClick();

        return this.slider;
    }

    onResize() {
        this.slider = this.destroySlider(this.slider);

        setTimeout(() => {
            this.slider = this.onLoad();
        }, Timeout.SHORT_TIMEOUT);
    }

    initPagination() {
        // Клик по пагинации
        this.pags.forEach(pag => {
            pag.addEventListener(`click`, (e) => {
                const index = e.target.getAttribute(`data-pag`);
                this.slider.slideTo(index);
            });
        });

        // Смена слайдов
        this.slider.on(`slideChange`, (e) => {
            this.pags.forEach(pag => {
                if (parseInt(pag.getAttribute(`data-pag`), 10) === this.slider.activeIndex) {
                    pag.classList.add(`active`);
                    getSiblings(pag).forEach(el => el.classList.remove(`active`));
                }
            });
        });
    }

    initSideSlideClick() {
        if (!this.block.getAttribute(`data-clicked-slide`)) return;

        const slideWidth = this.slider.slides[this.slider.activeIndex].swiperSlideSize;
        const containerWidth = this.block.offsetWidth;
        const viewSlidesLength = Math.ceil(containerWidth / slideWidth);

        this.getSliderLength().forEach((slide) => {
            slide.addEventListener(`click`, e => {
                const array = [];
                const index = parseInt(slide.getAttribute(`data-swiper-slide-index`));

                for (let i = 0; i < viewSlidesLength; i++) {
                    array.push(parseInt(this.slider.slides[this.slider.activeIndex + i].getAttribute(`data-swiper-slide-index`)));
                }

                if (!array.includes(index)) {
                    e.preventDefault();

                    if (slide.getBoundingClientRect().left > containerWidth) {
                        this.slider.slideNext();
                    } else {
                        this.slider.slidePrev();
                    }
                }
            });
        });
    }

    init() {
        if (!this.el) return false;

        this.slider = this.onLoad();
        isWidthResize(this.onWidthResize);
        return this.slider;
    }
}

export const initSliders = () => {
    const sliders = document.querySelectorAll(`[data-slider]`);
    if (!sliders.length) return;

    for (let i = 0; i < sliders.length; i++) {
        const swiper = new Slider(sliders[i]);
        swiper.init();
    }
}

